<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('companies.softwares.upload_learning_data')"
  :subtitle="$t('companies.softwares.upload_learning_data_description')"
  :rightActions="rightActions"
)
  UiFilePicker(
    v-model="file"
    placeholder="Choose a file or drop it here..."
    :extensions="['zip']"
  )
</template>
<script>
import ApiBaswareFiles from "@/api/basware_files.js";

export default {
  data() {
    return {
      show: false,
      file: null,
      company_id: null,
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.upload"),
          icon: "FileUpload",
          disabled: !this.file,
          onClick: this.upload,
        },
      ];
    },
  },

  methods: {
    open(company_id) {
      this.company_id = company_id;
      this.show = true;
    },

    close() {
      this.show = false;
    },

    upload() {
      let formData = new FormData();
      formData.append("file", this.file);
      ApiBaswareFiles.uploadFile(this.company_id, formData)
        .then((resp) => {
          this.$emit("done");
          this.close();
        })
        .catch((e) => {});
    },
  },
};
</script>
